import { twMergeExt } from '@/shared/utils/twMergeExt';
import { cva } from 'class-variance-authority';
import { FC } from 'react';

interface Props {
  className?: string;
  text: string;
}

export const ApplicationMethodTab: FC<Props> = ({ className, text }) => {
  return (
    <div className={twMergeExt(cvaRoot(), className)}>
      <div className={'flex flex-col gap-6.4 flex-shrink-0 flex-grow-0 md:basis-[45.6rem]'}>
        <h3 className={'text-h3 font-secondary max-w-[25.1rem]'}>Способ применения</h3>
      </div>

      <div className={'flex flex-col gap-2.4 flex-1 text-bodyL text-cBlack80'}>
        <div>{text}</div>
      </div>
    </div>
  );
};

const cvaRoot = cva([
  'ApplicationMethodTab-cvaRoot',
  ' flex md:gap-[15.9rem] flex-col md:flex-row md:px-o px-2.4 gap-2',
]);
